import Tab from '@components/tabs'
import { Fragment, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import Title from '@components/title'
import Column from '@components/column'

import { Profile } from '@commons/cards/profile'
import ProviderDetails from './provider-details'
import ActiveBookings from './active-bookings'
import CompletedBookings from './completed-bookings'
import CancelledBookings from './cancelled-bookings'
import Vehicles from './vehicles'
import OfferProvided from './offer-provided'
import Withdrawals from './withdrawals'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { Dashboard, User } from '@apis/index'
import StaffManagement from './staffs'
import { useModal } from '@context/ModalContext'
import { StatusUpdateModal } from '@commons/status-update-modal'

const IndividualProvider = () => {
  const { state: id } = useLocation()
  const { showModal, hideModal } = useModal()
  const navigate = useNavigate()
  const { data: dashboard, loading } = useSelector(
    (state: RootState) => state.dashboard,
  )
  const { data: user } = useSelector(
    (state: RootState) => state.inidividualUser,
  )
  const fetchDashboard = async () => {
    try {
      await Dashboard.list({ state: 'dashboard', params: { userId: id } })
    } catch (error) {}
  }

  const fetchUser = async () => {
    try {
      await User.find({ id: id, state: 'inidividualUser' })
    } catch (error) {}
  }
  useEffect(() => {
    fetchUser()
  }, [])
  useEffect(() => {
    fetchDashboard().then(() => {})
  }, [])
  const items = [
    {
      label: 'Provider Details',
      component: ProviderDetails,
      props: {
        user,
      },
    },
    {
      label: 'Active Bookings',
      component: ActiveBookings,
      props: {
        user,
      },
    },
    {
      label: 'Completed Bookings',
      component: CompletedBookings,
      props: {
        user,
      },
    },
    {
      label: 'Cancelled Bookings',
      component: CancelledBookings,
      props: {
        user,
      },
    },
    {
      label: 'Vehicles',
      component: Vehicles,
      props: {
        user,
        dashboard,
      },
    },
    {
      label: 'Offers Provided',
      component: OfferProvided,
      props: { user },
    },
    {
      label: 'Withdrawals',
      component: Withdrawals,
    },
    {
      label: 'Staffs',
      component: StaffManagement,
      props: { user },
    },
  ]

  return (
    <Fragment>
      <Column>
        <Title
          textone="Provider List >"
          texttwo="Details"
          textOneClick={() => navigate('/admin/user-management/providers')}
        />
        <Profile user={user} isUser={false} dashboard={dashboard} />
        <Tab items={items} />
      </Column>
      {!user?.infos?.hasOwnProperty('status') && (
        <StyleActionButtonContainer>
          <StyleActionButton
            variant="accept"
            onClick={() => {
              showModal(
                <StatusUpdateModal
                  item={user}
                  hideModal={hideModal}
                  actionType={'verify'}
                />,
              )
            }}
          >
            Accept
          </StyleActionButton>
          <StyleActionButton
            variant="reject"
            onClick={() => {
              showModal(
                <StatusUpdateModal
                  item={user}
                  hideModal={hideModal}
                  actionType={'reject'}
                />,
              )
            }}
          >
            Reject
          </StyleActionButton>
        </StyleActionButtonContainer>
      )}
    </Fragment>
  )
}

export default IndividualProvider

const StyleActionButtonContainer = styled.div`
  width: 100%;
  justify-content: flex-end;
  display: flex;
  column-gap: 10px;
  margin-top: 1.5rem;
`
const StyleActionButton = styled.button<{ variant?: string }>`
  border-radius: 12px;
  padding: 10px 60px;
  text-align: center;
  cursor: pointer;
  background: transparent;
  color: ${(props: any) => props.theme.colors[props.variant]};
  border: 1px solid ${(props: any) => props.theme.colors[props.variant]};
  transition: all 200ms linear;
  &:hover {
    scale: 1.04;
  }
  &:active {
    scale: 0.98;
  }
`
